import { ONBOARDING_STAGE } from 'src/data/onboarding';

export const AVAILABLE_ONBOARDING_STAGES = [
  ONBOARDING_STAGE.commonProjectWalkthrough,
  ONBOARDING_STAGE.productDescriptionWalkthrough,
  ONBOARDING_STAGE.briefEditing,
  ONBOARDING_STAGE.shopifyProductWalkthrough,
];
